import { ResourceOptions } from 'react-admin';
import { FaRobot } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingAgents;
export const icon = FaRobot;
export const options: ResourceOptions = {
  label: 'module.socialTrading.agents',
};
